import React, { useState } from 'react';

export default function SocialShare({ url, title, summary, hashtag = '#GradedWash' }) {
  const [showShareMenu, setShowShareMenu] = useState(false);
  const [copied, setCopied] = useState(false);

  const shareData = {
    title: title || 'Check out GradedWash - Find your perfect travel companion!',
    text: summary || 'Join thousands of travelers finding their ideal travel partners through personality matching.',
    url: url || window.location.href
  };

  const shareOptions = [
    {
      name: 'Facebook',
      icon: '📘',
      color: '#1877F2',
      action: () => {
        const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}&quote=${encodeURIComponent(title)}`;
        window.open(fbUrl, '_blank', 'width=600,height=400');
      }
    },
    {
      name: 'Twitter',
      icon: '🐦',
      color: '#1DA1F2',
      action: () => {
        const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}&hashtags=${hashtag.replace('#', '')}`;
        window.open(twitterUrl, '_blank', 'width=600,height=400');
      }
    },
    {
      name: 'LinkedIn',
      icon: '💼',
      color: '#0077B5',
      action: () => {
        const linkedinUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
        window.open(linkedinUrl, '_blank', 'width=600,height=400');
      }
    },
    {
      name: 'WhatsApp',
      icon: '💬',
      color: '#25D366',
      action: () => {
        const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(`${title} ${url} ${hashtag}`)}`;
        window.open(whatsappUrl, '_blank');
      }
    },
    {
      name: 'Email',
      icon: '📧',
      color: '#EA4335',
      action: () => {
        const emailUrl = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(`${summary}\n\n${url}\n\n${hashtag}`)}`;
        window.open(emailUrl);
      }
    },
    {
      name: 'Copy Link',
      icon: copied ? '✅' : '🔗',
      color: copied ? '#28a745' : '#6c757d',
      action: async () => {
        try {
          await navigator.clipboard.writeText(url);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        } catch (err) {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = url;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        }
      }
    }
  ];

  const handleNativeShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share(shareData);
      } catch (err) {
        console.log('Share cancelled or failed');
      }
    } else {
      setShowShareMenu(true);
    }
  };

  return (
    <div className="social-share">
      <div className="share-buttons">
        {/* Native Share Button (Mobile) */}
        <button 
          className="btn btn-primary share-button native-share"
          onClick={handleNativeShare}
        >
          📤 Share
        </button>

        {/* Desktop Share Menu */}
        {!navigator.share && (
          <div className="share-menu-container">
            <button 
              className="btn btn-secondary share-button"
              onClick={() => setShowShareMenu(!showShareMenu)}
            >
              📤 Share Options
            </button>
            
            {showShareMenu && (
              <div className="share-menu">
                <div className="share-menu-header">
                  <h4>Share this amazing content!</h4>
                  <button 
                    className="share-menu-close"
                    onClick={() => setShowShareMenu(false)}
                  >
                    ×
                  </button>
                </div>
                
                <div className="share-options">
                  {shareOptions.map((option, index) => (
                    <button
                      key={index}
                      className="share-option"
                      onClick={() => {
                        option.action();
                        setShowShareMenu(false);
                      }}
                      style={{ '--option-color': option.color }}
                    >
                      <span className="share-option-icon">{option.icon}</span>
                      <span className="share-option-name">{option.name}</span>
                    </button>
                  ))}
                </div>
                
                <div className="share-preview">
                  <div className="share-preview-content">
                    <h5>{title}</h5>
                    <p>{summary}</p>
                    <div className="share-preview-url">{url}</div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Quick Share Buttons */}
        <div className="quick-share-buttons">
          <button
            className="quick-share-btn facebook"
            onClick={() => shareOptions[0].action()}
            title="Share on Facebook"
          >
            📘
          </button>
          <button
            className="quick-share-btn twitter"
            onClick={() => shareOptions[1].action()}
            title="Share on Twitter"
          >
            🐦
          </button>
          <button
            className="quick-share-btn whatsapp"
            onClick={() => shareOptions[3].action()}
            title="Share on WhatsApp"
          >
            💬
          </button>
        </div>
      </div>

      {/* Share Stats */}
      <div className="share-stats">
        <div className="stat-item">
          <span className="stat-number">2.4k</span>
          <span className="stat-label">Shares</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">15.7k</span>
          <span className="stat-label">Views</span>
        </div>
        <div className="stat-item">
          <span className="stat-number">892</span>
          <span className="stat-label">New Members</span>
        </div>
      </div>
    </div>
  );
}

